import { render, staticRenderFns } from "./repairToBeAccepted.vue?vue&type=template&id=cb6370b8&scoped=true&"
import script from "./repairToBeAccepted.vue?vue&type=script&lang=js&"
export * from "./repairToBeAccepted.vue?vue&type=script&lang=js&"
import style0 from "./repairToBeAccepted.vue?vue&type=style&index=0&id=cb6370b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6370b8",
  null
  
)

export default component.exports